import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {IconoirNavArrowDown} from '@ey-xd/motif-icon';
import MotifDropdown from '../../../../../Common/BaseComponentWrappers/MotifDropdown';
import MotifDropdownItem from '../../../../../Common/BaseComponentWrappers/MotifDropdownItem';
import MotifButton from '@ey/motif-react-wrapper/Button';
import MotifIcon from '../../../../../Common/BaseComponentWrappers/MotifIcon';
import EllipsesControl from '../../../../../Common/EllipsesControl/EllipsesControl';
import Utility from '../../../../../../util/utilityfunctions';
import {labels} from '../../../../../../util/utils';

export default function FormRelatedEntities({relatedEntities}) {
	const [isOpen, setIsOpen] = useState(false);
	const handleToggle = () => setIsOpen((prev) => !prev);
	const setClickOutside = () => setIsOpen(false);

	const stEntities = useSelector((store) => store.stEntities);

	const formRelatedEntities = (relatedEntities && relatedEntities.map((id) => stEntities.byId[id])) || [];
	Utility.sortAlphaNumeric(formRelatedEntities, 'stEntityShortName');

	let chipLabel =
		formRelatedEntities?.length === 0 ? (
			<EllipsesControl noOfLines={1} content={labels.allEntities} tooltip={labels.allEntities} />
		) : formRelatedEntities.length === 1 ? (
			<EllipsesControl
				noOfLines={1}
				content={`${labels.entity}: ${formRelatedEntities[0].stEntityShortName}`}
				tooltip={`${labels.entity}: ${formRelatedEntities[0].stEntityShortName}`}
			/>
		) : (
			<EllipsesControl
				noOfLines={1}
				content={labels.relatedEntitiesCounter.replace('{0}', formRelatedEntities?.length)}
				tooltip={labels.relatedEntitiesCounter.replace('{0}', formRelatedEntities?.length)}
			/>
		);

	return (
		<>
			{formRelatedEntities?.length > 1 ? (
				<StyledFormRelatedEntities className="StyledFormRelatedEntities MoreEntity">
					<MotifDropdown
						className="RelatedEntitiesDropdown"
						open={isOpen}
						placement="bottom"
						id={'form-related-entities'}
						aria-labelledby={'form-related-entities-trigger'}
						handleClickOutside={setClickOutside}
						// closeOnOutsideClick={false}
						trigger={
							<MotifButton variant="secondary" type="button" onClick={handleToggle}>
								{chipLabel}
								<MotifIcon iconFunction={IconoirNavArrowDown} />
							</MotifButton>
						}
					>
						<section className="motif-dropdown-menu-section customScrollbar">
							{relatedEntities
								.map((id) => stEntities.byId[id])
								.map((entity) => {
									return (
										<MotifDropdownItem className="motif-body1-default-light">
											<EllipsesControl
												noOfLines={1}
												content={`${entity?.stEntityShortName} - ${entity?.stEntityName}`}
												tooltip={`${entity?.stEntityShortName} - ${entity?.stEntityName}`}
											/>
										</MotifDropdownItem>
									);
								})}
						</section>
					</MotifDropdown>
				</StyledFormRelatedEntities>
			) : (
				<StyledFormRelatedEntities className="StyledFormRelatedEntities LessEntity">
					<MotifButton type="button" variant="secondary">
						{chipLabel}
					</MotifButton>
				</StyledFormRelatedEntities>
			)}
		</>
	);
}

const StyledFormRelatedEntities = styled.section`
	display: inline-flex;
	justify-content: center;
	align-items: center;
	height: var(--px-32);
	min-width: var(--px-100);
	width: auto;
	max-width: var(--px-150);
	margin-right: var(--px-12);
	&.LessEntity {
		.motif-button {
			cursor: default;
			justify-content: center;
			min-width: unset;
			width: 100%;
		}
	}
	&.MoreEntity {
		.motif-button {
			cursor: pointer;
			justify-content: center;
			min-width: unset;
			width: 100%;
		}
		.RelatedEntitiesDropdown {
			display: flex;
			width: 100%;
			.motif-button {
				cursor: pointer;
				justify-content: center;
				min-width: unset;
				width: 100%;
			}
			.motif-dropdown-menu-section {
				height: auto;
				max-height: var(--px-350);
				overflow-y: auto;
				.motif-dropdown-item {
					cursor: default;
					.StyledEllipse {
						justify-content: flex-start;
					}
				}
			}
		}
	}
`;
